export default __webpack_public_path__ + "static/media/Toplu_Emniyet_Giris_Bildirimi.92abc9ae.xlsx";